import { useState } from 'react';

export default function usePagination(pageSize = 8) {
  const [pagination, setPagination] = useState({
    pageSize,
    currentPage: 1,
    totalPages: 0,
    totalRecords: 0,
  });

  const updateTotalRecords = (totalRecords) => {
    const totalPages = Math.ceil(totalRecords / pagination.pageSize);
    setPagination((previousState) => ({
      ...previousState,
      totalPages,
      currentPage: 1,
      totalRecords,
    }));
  };

  const goToPage = (pageNumber) => {
    setPagination((previousState) => ({ ...previousState, currentPage: pageNumber }));
  };

  const updatePageSize = (newPageSize) => {
    const totalPages = Math.ceil(pagination.totalRecords / newPageSize);
    setPagination((previousState) => ({
      ...previousState,
      totalPages,
      currentPage: 1,
      pageSize: newPageSize,
    }));
  };

  const getOffset = () => (pagination.currentPage - 1) * pagination.pageSize;

  return {
    pagination,
    ...pagination,
    updateTotalRecords,
    goToPage,
    updatePageSize,
    getOffset,
  };
}
